import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { TslDialog } from '@tesla/ng-tds';
import { DynamicFormComponent } from 'app/common/dynamic-form/dynamic-form.component';
import { NgDynamicFormComponent } from '@tesla/ng-dynamic-form';
import { SupplierDocument } from 'app/profile/models/supplier.model';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { DecrementLoaderCount, IncrementLoaderCount } from 'app/shared/store/actions';
import { isNotNullOrUndefined } from 'app/shared/utils/utils';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'ehs-edit',
  templateUrl: './ehs-edit.component.html'
})

export class EhsEditComponent implements OnChanges {

  /** Required supplier code to be provided by onboaridng parent component */
  @Input('tsl-supplierCode') supplierCode: string = '';
  @Input('tsl-formSchema') formSchema: any = '';
  @Input('tsl-formData') formData: any = '';
  @Input('tsl-readOnly') isReadOnly: boolean = false;

  @Output('tsl-onSave') onSubmitEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() customEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('dynamicFormComponent', { static: false }) public dynamicFormComponent: DynamicFormComponent;

  constructor(private dialog: TslDialog,
    private supplierStateService: SupplierStateService,
    private snackBar: MatSnackBar,
    private store: Store<SupplierState>) { }
  ngOnChanges(changes: SimpleChanges): void {
  }

  save(event: any): void {
    if (event) {
      if (event.formData) {
        if (this.hasAllNegativeResponse(event.formData)) {
          this.dialog.confirm('Confirmation', 'All your answers are negative. Are you sure you have selected correct responses?')
            .afterClosed().subscribe((response: boolean) => {
              if (response) {
                this.onSubmitEvent.emit({ ehsResponse: event.formData });
              }
            });
        }
        else {
          this.onSubmitEvent.emit({ ehsResponse: event.formData });
        }
      }
      if (event?.action === 'download') {
        var document = new SupplierDocument();
        document.FileName = event.file?.fileName;
        document.DocumentID = event.file?.documentId;
        document.File = event.file?.file;
        this.downloadDocument(document);
      }
    }
  }

  downloadDocument(document: SupplierDocument) {
    document.ReferenceSystem = 'DMS';
    if (document && isNotNullOrUndefined(document.File)) {
      FileSaver.saveAs(document.File, document.FileName || document.DocumentID);
    } else {
      if (document && document.DocumentID) {
        this.store.dispatch(new IncrementLoaderCount());
        this.supplierStateService.downloadFile(this.supplierCode, document.ReferenceSystem, document.DocumentID, document.DocumentVersion)
          .subscribe(response => {
            this.store.dispatch(new DecrementLoaderCount());
            FileSaver.saveAs(response, document.FileName || document.DocumentID);
          }, (error) => {
            console.log(error);
            this.store.dispatch(new DecrementLoaderCount());
            this.snackBar.open(`Something went wrong. Unable to download!`, null, {
              duration: 5000,
              verticalPosition: 'top',
              panelClass: ['red-snackbar']
            });
          });
      }
    }
  }

  hasAllNegativeResponse(data: any): boolean {
    for (var key in data) {
      if (data[key] == "1") {
        return false;
      }
    }
    return true;
  }
  
  getUpdatedForm() { 
    const { updatedData, updatedSchema } = this.dynamicFormComponent.handleFormChange();

    return {
      updatedData: updatedData,
      updatedSchema: updatedSchema
    };
  }
}
